import { useState } from "react";
import { FaUpload } from "react-icons/fa";
import Sidebar from "../Sidebar/Sidebar";
import "./UploadInventoryCSV.css";

const UploadInventoryCSV = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [errorList, setErrorList] = useState([]);

  // Use the same token key as CreatePharmacyBranch
  const token = localStorage.getItem("access_token");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage("");
    setErrorList([]);
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage("❌ Please select a CSV file first.");
      return;
    }

    if (!token) {
      setMessage("❌ No valid token found. Please log in again.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setUploading(true);
      const response = await fetch(
        "http://127.0.0.1:8000/pharmacies/upload-inventory-csv",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (response.status === 401) {
        throw new Error("Could not validate credentials. Please log in again.");
      }

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Upload failed.");
      }

      const result = await response.json();
      setMessage(
        `✅ Added: ${result.added}, Skipped: ${result["skipped (duplicates)"]}, Errors: ${result.errors.length}`
      );
      setErrorList(result.errors || []);
    } catch (err) {
      setMessage(`❌ ${err.message}`);
      setErrorList([]);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="layout">
      <Sidebar />
      <div className="main-content">
        <h1 className="title">📤 Upload Inventory CSV</h1>

        {message && <p className="upload-message">{message}</p>}

        {errorList.length > 0 && (
          <div className="error-list">
            <h4>Details:</h4>
            <ul>
              {errorList.map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          </div>
        )}

        <div className="upload-section">
          <input type="file" accept=".csv" onChange={handleFileChange} />
          <button onClick={handleUpload} disabled={uploading}>
            <FaUpload style={{ marginRight: "5px" }} />{" "}
            {uploading ? "Uploading..." : "Upload CSV"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadInventoryCSV;
